import { render, staticRenderFns } from "./Cpic.vue?vue&type=template&id=0b1d8eb0&scoped=true"
import script from "./Cpic.vue?vue&type=script&lang=js"
export * from "./Cpic.vue?vue&type=script&lang=js"
import style0 from "./Cpic.vue?vue&type=style&index=0&id=0b1d8eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d8eb0",
  null
  
)

export default component.exports